import {
  Button,
  Divider,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
} from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { MergedHoldingMethodStep } from '@blockpulse3/graphql/hooks';
import {
  ResponsiveModal,
  ResponsiveModalFooter,
  ResponsiveModalProps,
} from '@blockpulse3/ui/commons';

import { SubscriptionHoldingMethod } from '../../../SubscriptionHoldingMethod';

type Props = {
  onClose: () => void;
  onSubmit: () => void;
  subscriptionStep: MergedHoldingMethodStep;
} & Omit<ResponsiveModalProps, 'children'>;

export function HoldingMethodModal({
  onClose,
  onSubmit,
  subscriptionStep,
  ...props
}: Props): JSX.Element {
  const i18nGeneral = useTranslations('General');
  const i18nSubscription = useTranslations('Subscription');

  return (
    <ResponsiveModal onClose={onClose} {...props}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="xl" p="4">
          {i18nSubscription('SupportSelection')}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody as={Stack}>
          <SubscriptionHoldingMethod />
        </ModalBody>
        <Divider />
        <ResponsiveModalFooter>
          <Button type="button" variant="secondary" onClick={onClose}>
            {i18nGeneral('Cancel')}
          </Button>
          <Button onClick={onSubmit}>{i18nGeneral('Submit')}</Button>
        </ResponsiveModalFooter>
      </ModalContent>
    </ResponsiveModal>
  );
}
